module.exports = __webpack_public_path__ + "static/media/education_lady.ed6fb8c1.png";